/* tslint:disable */
/* eslint-disable */
/* @relayHash 99b1b840841e8dd29b1ae69b885613b2 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IllegalContentReportViewQueryVariables = {
    commentID: string;
    storyID?: string | null;
    storyURL?: string | null;
};
export type IllegalContentReportViewQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_story">;
    } | null;
    readonly comment: {
        readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_comment">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_settings">;
    };
};
export type IllegalContentReportViewQuery = {
    readonly response: IllegalContentReportViewQueryResponse;
    readonly variables: IllegalContentReportViewQueryVariables;
};



/*
query IllegalContentReportViewQuery(
  $commentID: ID!
  $storyID: ID
  $storyURL: String
) {
  viewer {
    ...IllegalContentReportViewContainer_viewer
    id
  }
  story(id: $storyID, url: $storyURL) {
    ...IllegalContentReportViewContainer_story
    id
  }
  comment(id: $commentID) {
    ...IllegalContentReportViewContainer_comment
    id
  }
  settings {
    ...IllegalContentReportViewContainer_settings
    id
  }
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment ArchivedReportFlowContainer_settings on Settings {
  organization {
    name
    contactEmail
  }
}

fragment AuthorBadgesContainer_settings on Settings {
  flairBadges {
    flairBadgesEnabled
    badges {
      name
      url
    }
  }
}

fragment BadgeTagContainer_settings on Settings {
  badges {
    staffLabel
    adminLabel
    moderatorLabel
    memberLabel
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment CommentContainer_settings on Settings {
  flattenReplies
  collapseReplies
  disableCommenting {
    enabled
  }
  topCommenter {
    enabled
  }
  newCommenter {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...EditCommentFormContainer_settings
  ...MediaSectionContainer_settings
  ...ReactionButtonContainer_settings
  ...ModerationRejectedTombstoneContainer_settings
  ...ReplyCommentFormContainer_settings
  ...ReportFlowContainer_settings
  ...UsernameWithPopoverContainer_settings
  ...UserTagsContainer_settings
  ...ArchivedReportFlowContainer_settings
  ...AuthorBadgesContainer_settings
  ...ReportButton_settings
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  isArchiving
  isArchived
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
  ...ModerationRejectedTombstoneContainer_story
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportFlowContainer_viewer
  ...ReportButton_viewer
  ...CaretContainer_viewer
  ...ModerationRejectedTombstoneContainer_viewer
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment CopyCommentEmbedCodeContainer_settings on Settings {
  embeddedComments {
    allowReplies
  }
  reaction {
    label
  }
}

fragment CopyCommentEmbedCodeContainer_story on Story {
  url
}

fragment CreateCommentMutation_viewer on User {
  id
  avatar
  badges
  bio
  createdAt
  role
  username
  featuredCommenter
  newCommenter
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  featuredCommenter
  status {
    current
    ban {
      active
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      key
      maxRating
      provider
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment IllegalContentReportViewContainer_comment on Comment {
  id
  status
  revision {
    id
  }
  ...RejectedTombstoneContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
  ...CommentContainer_comment
}

fragment IllegalContentReportViewContainer_settings on Settings {
  ...UserBoxContainer_settings
  ...CommentContainer_settings
}

fragment IllegalContentReportViewContainer_story on Story {
  id
  url
  ...CommentContainer_story
}

fragment IllegalContentReportViewContainer_viewer on User {
  id
  ...UserBoxContainer_viewer
  ...CreateCommentMutation_viewer
  ...CreateCommentReplyMutation_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
  ...CommentContainer_viewer
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      provider
    }
    external {
      enabled
    }
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
  ...CopyCommentEmbedCodeContainer_settings
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
  ...CopyCommentEmbedCodeContainer_story
}

fragment ModerationActionsContainer_viewer on User {
  id
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
  ...UserBanPopoverContainer_settings
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
  ...UserBanPopoverContainer_viewer
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ModerationRejectedTombstoneContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
  ...CaretContainer_settings
}

fragment ModerationRejectedTombstoneContainer_story on Story {
  ...CaretContainer_story
}

fragment ModerationRejectedTombstoneContainer_viewer on User {
  ...CaretContainer_viewer
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
  status
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      key
      maxRating
      provider
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportButton_settings on Settings {
  dsa {
    enabled
  }
}

fragment ReportButton_viewer on User {
  id
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportFlowContainer_settings on Settings {
  dsa {
    enabled
  }
  ...ReportCommentFormContainer_settings
}

fragment ReportFlowContainer_viewer on User {
  id
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserBanPopoverContainer_viewer on User {
  moderationScopes {
    scoped
  }
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment UserBoxContainer_viewer on User {
  username
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_settings on Settings {
  ...BadgeTagContainer_settings
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentID"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "storyID"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "storyURL"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v2 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "commentID"
        } as any)
    ], v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avatar",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "badges",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bio",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "featuredCommenter",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newCommenter",
        "storageKey": null
    } as any), v11 = [
        (v3 /*: any*/)
    ], v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v17 = [
        (v12 /*: any*/),
        (v15 /*: any*/)
    ], v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v19 = [
        (v18 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ], v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any), v21 = [
        (v18 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "IllegalContentReportViewQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IllegalContentReportViewContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IllegalContentReportViewContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IllegalContentReportViewContainer_comment"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "IllegalContentReportViewContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "IllegalContentReportViewQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        (v9 /*: any*/),
                        (v10 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": (v11 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v12 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v13 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentRevision",
                            "kind": "LinkedField",
                            "name": "revision",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "media",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v12 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "still",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "video",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GiphyMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v17 /*: any*/),
                                            "type": "TwitterMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v17 /*: any*/),
                                            "type": "BlueskyMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v12 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/)
                                            ],
                                            "type": "YouTubeMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v12 /*: any*/)
                                            ],
                                            "type": "ExternalMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v12 /*: any*/),
                                                (v14 /*: any*/)
                                            ],
                                            "type": "TenorMedia",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v8 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ignoreable",
                                    "storageKey": null
                                },
                                (v7 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deleted",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v3 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                        },
                        (v8 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rating",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EditInfo",
                            "kind": "LinkedField",
                            "name": "editing",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "edited",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "editableUntil",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "code",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActionCounts",
                            "kind": "LinkedField",
                            "name": "actionCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReactionActionCounts",
                                    "kind": "LinkedField",
                                    "name": "reaction",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "total",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActionPresence",
                            "kind": "LinkedField",
                            "name": "viewerActionPresence",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dontAgree",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flag",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "reaction",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "illegal",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seen",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canReply",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": (v11 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Story",
                            "kind": "LinkedField",
                            "name": "story",
                            "plural": false,
                            "selections": [
                                (v12 /*: any*/),
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastViewerAction",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spamBanned",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pending",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasTraversalFocus",
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "local",
                                            "plural": false,
                                            "selections": (v19 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "oidc",
                                            "plural": false,
                                            "selections": (v19 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "google",
                                            "plural": false,
                                            "selections": (v19 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "facebook",
                                            "plural": false,
                                            "selections": (v19 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v18 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flattenReplies",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "collapseReplies",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                (v20 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TopCommenterConfiguration",
                            "kind": "LinkedField",
                            "name": "topCommenter",
                            "plural": false,
                            "selections": (v21 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewCommenterConfiguration",
                            "kind": "LinkedField",
                            "name": "newCommenter",
                            "plural": false,
                            "selections": (v21 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmbeddedCommentsConfiguration",
                            "kind": "LinkedField",
                            "name": "embeddedComments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowReplies",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "icon",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BlueskyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "bluesky",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GifMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "gifs",
                                    "plural": false,
                                    "selections": [
                                        (v18 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "provider",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v20 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DSAConfiguration",
                            "kind": "LinkedField",
                            "name": "dsa",
                            "plural": false,
                            "selections": (v21 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "BadgeConfiguration",
                            "kind": "LinkedField",
                            "name": "badges",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "memberLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                                (v13 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contactEmail",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlairBadgeConfiguration",
                            "kind": "LinkedField",
                            "name": "flairBadges",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flairBadgesEnabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlairBadge",
                                    "kind": "LinkedField",
                                    "name": "badges",
                                    "plural": true,
                                    "selections": [
                                        (v13 /*: any*/),
                                        (v12 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "99b1b840841e8dd29b1ae69b885613b2",
            "metadata": {},
            "name": "IllegalContentReportViewQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3f114568adb27aaa14f9f14327f03c9d';
export default node;
